import React from 'react'
import Biography from '../biography/Biography'
import VideoPlayer from '../biography/VideoPlayer'

const BiographyPage = () => {
  return (
    <div>
        <Biography />
        <VideoPlayer />
    </div>
  )
}

export default BiographyPage


